//@ts-check

//@ts-ignore
const { delay } = require('common-stuffs/utils')(fox);
const { ENV_VAR_NAME_TOS } = require('GDPR-popups/constants.es');

const ENV_VAR_NAME = ENV_VAR_NAME_TOS;

/**
 * 
 * @param {Fox} fox
 */
module.exports = (fox) => {
	const site = fox.wom.getRoot();
	const gdprPopup = site.rwom1('#gdprMainPopup');

	let promise = fox.Promise.resolve();
	let shouldShow = fox.getEnv(ENV_VAR_NAME);
	let deniedGap = null;

	if (!site.rwom1('#permissionManager').hasAccess('guestActual')) {
		if (location.pathname === '/terms') {
			deniedGap = new fox.Promise((resolve) => {
				const handler = site.handleEvent('.Site_Layout', 'switchedEmbeddedWidget', (page) => {
					if (page !== 'terms') {
						handler.drop();

						return resolve(true);
					}
				});
			});
		}
	}

	if (shouldShow) {
		if (!fox.ready) {
			promise = promise.then(() => site.wait('fox_ready'));
		} else {
			promise = promise.then(() => delay(2000));
		}

		if (deniedGap) {
			promise = promise.then(() => deniedGap);
		}

		return promise.then(() => gdprPopup.showForMember().then((result) => {
			if (result) {
				fox.setEnv(ENV_VAR_NAME, false);
			}
		}));
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/show-gdpr-popup.es.js